import React from "react"

import Layout from "../components/layout"
import ContactMainArea from "../components/ContactMainArea"
// import ContactPage from "../components/ContactPage"
import { graphql } from "gatsby"
import useWebsiteCmsContent from "../hooks/useWebsiteCmsContent"
import { localizedBlockData } from "../services/websiteCms"

const Contact = ({
  data: {
    markdownRemark: {
      frontmatter: { mapSection, lang, ...rest },
    },
  },
}) => {
  const cmsPayload = useWebsiteCmsContent()
  const page = localizedBlockData(cmsPayload, "contact-page", lang) || {}
  const active = { ...rest, ...page }

  return (
    <Layout lang={lang} title={active.title || "Contact"}>
      <ContactMainArea {...active} />
    </Layout>
  )
}

export default Contact


export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        lang
        description
        addressTitle
        addressText
        phone
        phoneList
        {
          title
          link

        }
        emailTitle
        emailLink
        workingHourse
        workingHourseText
        mapSection
         {
          from
          map
          sendButton
         }
      }
    }
  }
  `